import { SchedulerItem } from '../models/item';

export const orderByRankWithMachine = <Type extends SchedulerItem>(
  list: Type[],
  machineId: number
): Type[] => {
  return list
    .sort((a, b) => {
      const itemOnMachineA = a.getItemOnMachineByMachineId(machineId);
      const itemOnMachineB = b.getItemOnMachineByMachineId(machineId);
      if (itemOnMachineA?.rank < itemOnMachineB?.rank) {
        return -1;
      }
      if (itemOnMachineA?.rank > itemOnMachineB?.rank) {
        return 1;
      }
      return 0;
    })
    .map((item, index) => {
      item.rankNumber = index + 1;
      return item;
    });
};
